import { useCallback, useEffect, useState } from "react";
import { API } from "@/App";
import { Copy, Package, Link2 } from "lucide-react";
import { LinkPendingPanel } from "@/components/LinkPendingPanel";
import { PackageRequestPanel } from "@/components/PackageRequestPanel";
import { RestrictedBadge } from "@/components/MemberRestriction";

export const MemberAlerts = ({ businessId, refreshKey, onChanged, onSell, sellSignal, onBadges }) => {
  const [b, setB] = useState(null);
  const [open, setOpen] = useState(null);
  const load = useCallback(() => {
    if (!businessId) return;
    fetch(`${API}/businesses/${businessId}/member-badges`, { credentials: "include" })
      .then((r) => (r.ok ? r.json() : null)).then((d) => { setB(d); onBadges?.(d); }).catch(() => setB(null));
  }, [businessId]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [load, refreshKey, sellSignal]);
  useEffect(() => { if (b && open === "link" && !b.link_pending) setOpen(null); if (b && open === "pkg" && !b.package_requests) setOpen(null); }, [b, open]);
  if (!b?.total) return null;

  const Pill = ({ k, n, label, Icon, cls }) => n > 0 && (
    <button type="button" onClick={() => setOpen(open === k ? null : k)} data-testid={`member-alert-${k}`}
      className={`inline-flex items-center gap-2 rounded-full border px-3.5 py-2 text-sm font-semibold transition-colors ${cls} ${open === k ? "ring-2 ring-offset-1 ring-current" : ""}`}>
      <Icon className="w-4 h-4" />{label}
      <span className="rounded-full bg-white/80 px-2 py-0.5 text-xs font-bold">+{n}</span>
    </button>
  );
  const changed = () => { load(); onChanged?.(); };
  return (
    <div className="space-y-3" data-testid="member-alerts">
      <div className="flex flex-wrap gap-2">
        <Pill k="link" n={b.link_pending} label="Olası Tekrar Kayıt" Icon={Copy} cls="border-amber-300 bg-amber-50 text-amber-800 hover:bg-amber-100" />
        <Pill k="pkg" n={b.package_requests} label="Paket Talebi" Icon={Package} cls="border-orange-300 bg-orange-50 text-orange-800 hover:bg-orange-100" />
      </div>
      {open === "link" && <LinkPendingPanel businessId={businessId} onChanged={changed} refreshKey={refreshKey} />}
      {open === "pkg" && <PackageRequestPanel businessId={businessId} onSell={onSell} refreshSignal={sellSignal} />}
    </div>
  );
};

export const MemberFlags = ({ member, pkgReqIds }) => (
  <>
    <RestrictedBadge member={member} />
    {member.source === "public_booking_link" && (
      <span className="inline-flex items-center gap-0.5 text-[10px] font-semibold px-1.5 py-0.5 rounded-full border border-emerald-300 bg-emerald-50 text-emerald-700" data-testid={`member-flag-link-${member.member_id}`}><Link2 className="w-3 h-3" />Linkten</span>
    )}
    {member.possible_duplicate_of?.length > 0 && (
      <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full border border-amber-300 bg-amber-50 text-amber-700" data-testid={`member-flag-duplicate-${member.member_id}`}>Olası Tekrar</span>
    )}
    {pkgReqIds?.includes(member.member_id) && (
      <span className="text-[10px] font-semibold px-1.5 py-0.5 rounded-full border border-orange-300 bg-orange-50 text-orange-700" data-testid={`member-flag-pkgreq-${member.member_id}`}>Paket Talebi</span>
    )}
  </>
);
